import React, { useState, useEffect, Fragment } from "react";
import parse from "html-react-parser";
import { hostname } from "../../constants";

import Page from "../../layouts/Page";
import TextBlock from "../../components/TextBlock";
import styles from "./styles.module.sass";

interface LayoutItem {
  acf_fc_layout: string;
  header?: string;
  image?: { sizes: { [key: string]: string } };
}

interface BrandData {
  content: { rendered: string };
  acf: { layout: LayoutItem[] };
}

const Brand: React.FC = () => {
  const [data, setData] = useState<BrandData | null>(null);

  useEffect(() => {
    fetch(`${hostname}/wp-json/wp/v2/pages/72847`)
      .then((res) => res.json())
      .then((json) => setData(json))
      .catch(console.error);
  }, []);

  if (!data) return null;

  return (
    <Page className={styles.base}>
      <Fragment>
        <TextBlock className={styles.intro} width="none">
          {parse(data.content.rendered)}
        </TextBlock>
        {data.acf.layout.map((layout, idx) =>
          layout.acf_fc_layout === "large_header" ? (
            <TextBlock key={idx} className={styles.intro} width={800}>
              {layout.header && parse(layout.header)}
            </TextBlock>
          ) : (
            <img
              key={`image${idx}`}
              src={layout.image?.sizes['twentyseventeen-featured-image']}
              className={styles.photo}
              alt=""
            />
          )
        )}
      </Fragment>
    </Page>
  );
};

export default Brand;
